import type { AppData } from './app-data';
import type { EditResult } from './plan-service';
import type { Action } from './reducer';

/**
 * DE: Zugriff auf die neuesten Daten und auf Änderungen, die sofort gelten.
 * EN: Access to the newest data and to changes that apply at once.
 */
export interface PlanStore {
  read: () => AppData;
  apply: (action: Action) => void;
}

/**
 * DE: Eine Plan-Rechnung auf gegebenen Daten (im Worker oder auf der Seite).
 * EN: A plan calculation on given data (in the worker or on the page).
 */
export type PlanCalculation = (data: AppData) => Promise<EditResult>;

/**
 * DE: Rechnet und speichert den Plan; ändern sich die Daten währenddessen, wird mit den neuen Daten
 * noch einmal gerechnet, damit nichts überschrieben wird (ADR 0011).
 * EN: Calculates and stores the plan; when the data changes meanwhile, it calculates again with the
 * new data so that nothing is overwritten (ADR 0011).
 */
export function createPlanRunner(store: PlanStore) {
  return async (calculate: PlanCalculation): Promise<EditResult> => {
    let input = store.read();
    let result = await calculate(input);
    while (store.read() !== input) {
      input = store.read();
      result = await calculate(input);
    }
    store.apply({ type: 'store-plan', plan: result.stored });
    return result;
  };
}
